import { useState } from 'react';
import { OnboardingStep } from './onboardingTypes';
import { DisclaimerStep } from './DisclaimerStep';
import { SidebarTourStep } from './SidebarTourStep';
import { PrePromptsTourStep } from './PrePromptsTourStep';

interface ChatOnboardingProps {
    onComplete: () => void;
}

export const ChatOnboarding = ({ onComplete }: ChatOnboardingProps) => {
    const [step, setStep] = useState<OnboardingStep>('disclaimer');

    switch (step) {
        case 'disclaimer':
            return <DisclaimerStep onAccept={() => setStep('sidebar')} />;
        case 'sidebar':
            return <SidebarTourStep onNext={() => setStep('prePrompts')} />;
        case 'prePrompts':
            return <PrePromptsTourStep onNext={onComplete} />;
    }
};
